'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _ = require('lodash');
var FaresOptimizerAnalysisController = function FaresOptimizerAnalysisController($scope, $rootScope, currentStateCriteriaService, faresOptimizerAnalysisDataService, searchCriteriaRsqlQueryService, SearchCriteriaRule, configurationService) {
  $scope.initializeState = function () {
    $scope.screenState = {};
    $scope.screenState.rawData = [];
    $scope.screenState.failureLogData = [];
    $scope.screenState.sideFilterExpanded = true;
    $scope.screenState.recommendationDetailsPanel = {
      visible: false,
      contextData: {}
    };
  };
  $scope.initializeState();
  function updateSearchCriteriaToIncludeBiDirectionalMarket() {
    if ($scope.screenState.recommendMode !== 'ADAPTIVE') {
      return;
    }
    $scope.searchCriteria.rules.filter(function (rule) {
      return rule.criterion === 'Market' && rule.leftOperand !== undefined;
    }).forEach(function (rule) {
      rule.leftOperand = _.uniq(rule.leftOperand.flatMap(function (market) {
        var _market$split = market.split('-'),
          _market$split2 = (0, _slicedToArray2["default"])(_market$split, 2),
          origin = _market$split2[0],
          destination = _market$split2[1];
        return [market, "".concat(destination, "-").concat(origin)];
      }));
    });
  }
  function buildRsqlQuery() {
    $scope.searchCriteria = _.cloneDeep(currentStateCriteriaService.getSearchCriteria());
    updateSearchCriteriaToIncludeBiDirectionalMarket();
    $scope.isLastSnapshotRecommendations = currentStateCriteriaService.isLastSnapshotRecommendations();
    var strategyRule = new SearchCriteriaRule({
      field: $scope.screenState.recommendMode !== 'ADAPTIVE' ? 'category' : 'carrier',
      operator: '=',
      leftOperand: $scope.screenState.recommendMode !== 'ADAPTIVE' ? $scope.screenState.recommendMode : configurationService.getHostCarrier()
    });
    if (!_.isNil($scope.isLastSnapshotRecommendations) && $scope.isLastSnapshotRecommendations) {
      var validatedRecommendationsRule = new SearchCriteriaRule({
        field: 'retrieveLastSnapshot',
        operator: '=',
        leftOperand: $scope.isLastSnapshotRecommendations
      });
      $scope.rsqlQuery = searchCriteriaRsqlQueryService.getRsqlQueryFromSearchCriteriaRules($scope.searchCriteria.rules.concat([strategyRule, validatedRecommendationsRule]), $scope.screenState.recommendMode);
    } else {
      $scope.rsqlQuery = searchCriteriaRsqlQueryService.getRsqlQueryFromSearchCriteriaRules($scope.searchCriteria.rules.concat([strategyRule]), $scope.screenState.recommendMode);
    }
  }
  $scope.reloadFOScreen = function () {
    buildRsqlQuery();
    faresOptimizerAnalysisDataService.getRecommendationData($scope.rsqlQuery, $scope.screenState.recommendMode).then(function (data) {
      if (data.length === 0) {
        $rootScope.$broadcast('search-criteria:no-results');
      }
      $scope.screenState.rawData = data;
      $scope.screenState.competitorLadderData = [];
      $scope.screenState.webFaresByKey = [];
      $scope.screenState.tacticalFareDefinitionDataByAttributes = [];
      $scope.screenState.reloadFilters = true;
    });
  };
  $rootScope.$on('fo:change:recommendationMode', function () {
    $scope.reloadFOScreen();
  });
  $rootScope.$on('foAnalysisToolbar:recalculatedFarePresent', function (evt, param) {
    $rootScope.$broadcast('foAnalysisToolbar:recalculatedFarePresent:showConfirmModal', param);
  });
};
FaresOptimizerAnalysisController.$inject = ['$scope', '$rootScope', 'CurrentStateCriteriaService', 'FaresOptimizerAnalysisDataService', 'SearchCriteriaRsqlQueryService', 'SearchCriteriaRuleFactory', 'ConfigurationService'];
module.exports = FaresOptimizerAnalysisController;